// confirm.js
import Vue from 'vue';
import Confirm from './index.vue';

const ConfirmConstructor = Vue.extend(Confirm);

function showConfirm(options) {
  return new Promise((resolve) => {
    const instance = new ConfirmConstructor({
      data: options,
    });

    instance.$mount()

    document.body.appendChild(instance.$el);

    instance.resolve = resolve;
    instance.show = true;
  });
}

export { showConfirm };

export default {
  install(Vue) {
    Vue.prototype.$wondercv = Vue.prototype.$wondercv || {};
    Vue.prototype.$wondercv.showConfirm = showConfirm;
  },
};
